let locationEntityIndex = 0;
export async function setEarthCenter(item) {
  const { viewer, Cesium } = window;
  const id = 'locationEntity' + locationEntityIndex++;
  const locationEntity = viewer.entities.add({
    name: id,
    id: id,
    polyline: {
      positions: [
        Cesium.Cartesian3.fromDegrees(item.lon, item.lat, 0),
        Cesium.Cartesian3.fromDegrees(item.lon, item.lat, item.height || 10000)
      ],
      width: 4,
      material: Cesium.Color.WHITE.withAlpha(0)
    }
  });
  try {
    const res = await viewer.flyTo(locationEntity, {
      duration: 1,
      offset: {
        heading: viewer.scene.camera.heading,
        roll: viewer.scene.camera.roll,
        pitch: viewer.scene.camera.pitch
      }
    });
    viewer.entities.remove(locationEntity);
    console.log('flyto', res);
  } catch (e) {
    console.log('flyto', e);
  }
}